var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAngry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.8569C42.3301 52.8569 52.3256 42.6233 52.3256 29.9997C52.3256 17.3761 42.3301 7.14258 30 7.14258C17.67 7.14258 7.67444 17.3761 7.67444 29.9997C7.67444 42.6233 17.67 52.8569 30 52.8569Z",
    fill: "url(#paint0_radial_4760_27471)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5675 39.2861C29.5675 39.2861 34.2 39.2718 35.7907 43.0433C35.8884 43.2861 35.9581 43.5432 35.9721 43.8004C36.014 44.329 35.6512 44.8718 34.7721 44.5147C33.3628 43.9433 30.9349 43.6575 29.5675 43.6575C28.2 43.6575 25.7861 43.9433 24.3628 44.5147C23.4837 44.8718 23.1209 44.329 23.1628 43.8004C23.1768 43.5432 23.2465 43.2861 23.3442 43.0433C24.9488 39.2718 29.5675 39.2861 29.5675 39.2861Z",
    fill: "url(#paint1_radial_4760_27471)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7163 35.7997C23.9032 35.7997 24.8652 34.3095 24.8652 32.4712C24.8652 30.6329 23.9032 29.1426 22.7163 29.1426C21.5296 29.1426 20.5675 30.6329 20.5675 32.4712C20.5675 34.3095 21.5296 35.7997 22.7163 35.7997Z",
    fill: "url(#paint2_radial_4760_27471)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8652 31.2717C23.121 31.2717 24.1675 32.586 24.4745 34.3717C24.7257 33.8289 24.8652 33.1717 24.8652 32.4575C24.8652 30.6146 23.9024 29.1289 22.7163 29.1289C21.6838 29.1289 20.8186 30.2432 20.6093 31.7432C20.9861 31.4432 21.4047 31.2717 21.8652 31.2717Z",
    fill: "url(#paint3_linear_4760_27471)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4139 24.3574C18.4883 24.3574 16.8418 26.6289 18.9906 26.9717C21.1395 27.3146 25.0465 29.2146 26.7069 30.5289C26.8325 30.686 27.3209 30.6288 27.279 30.2431C27.279 28.7574 22.7581 24.3574 20.4139 24.3574Z",
    fill: "url(#paint4_linear_4760_27471)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5675 40.529C29.5675 40.529 33.335 40.5146 35.9164 43.4861C35.8885 43.3289 35.8466 43.1861 35.7768 43.0433C34.1861 39.2718 29.5535 39.2861 29.5535 39.2861C29.5535 39.2861 24.921 39.2718 23.3303 43.0433C23.2745 43.1861 23.2326 43.3289 23.1907 43.4861C25.8 40.5146 29.5675 40.529 29.5675 40.529Z",
    fill: "url(#paint5_linear_4760_27471)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2838 35.7997C38.4705 35.7997 39.4326 34.3095 39.4326 32.4712C39.4326 30.6329 38.4705 29.1426 37.2838 29.1426C36.097 29.1426 35.1349 30.6329 35.1349 32.4712C35.1349 34.3095 36.097 35.7997 37.2838 35.7997Z",
    fill: "url(#paint6_radial_4760_27471)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1349 31.2717C36.8791 31.2717 35.8326 32.586 35.5256 34.3717C35.2744 33.8289 35.1349 33.1717 35.1349 32.4575C35.1349 30.6146 36.0977 29.1289 37.2838 29.1289C38.3163 29.1289 39.1814 30.2432 39.3908 31.7432C39.014 31.4432 38.5954 31.2717 38.1349 31.2717Z",
    fill: "url(#paint7_linear_4760_27471)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.586 24.3574C41.5115 24.3574 43.158 26.6289 41.0092 26.9717C38.8604 27.3146 34.9534 29.2146 33.2929 30.5289C33.1674 30.686 32.679 30.6288 32.7209 30.2431C32.7209 28.7574 37.2418 24.3574 39.586 24.3574Z",
    fill: "url(#paint8_linear_4760_27471)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9683 20.9005) rotate(-30.2816) scale(22.6629 18.7334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5699 41.96) scale(4.88835 2.66603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4760_27471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0587 32.5468) rotate(74.2104) scale(3.22381 2.04452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4760_27471",
    x1: 22.7364,
    y1: 30.1521,
    x2: 22.7364,
    y2: 33.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4760_27471",
    x1: 22.6284,
    y1: 32.2745,
    x2: 22.6284,
    y2: 25.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_27471",
    x1: 29.57,
    y1: 37.6623,
    x2: 29.57,
    y2: 41.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4760_27471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.003 32.493) rotate(105.789) scale(3.22381 2.04451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4760_27471",
    x1: 37.2637,
    y1: 30.1521,
    x2: 37.2637,
    y2: 33.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4760_27471",
    x1: 37.3715,
    y1: 32.2745,
    x2: 37.3715,
    y2: 25.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngry);
export default __webpack_public_path__ + "static/media/icon_angry.ba11e7c5e53e97b430c5ac3cebe7b6a4.svg";
export { ForwardRef as ReactComponent };